module.exports = __webpack_public_path__ + "static/media/nl.d4811c27.svg";